import styled from 'vue-styled-components'
import { breakpointStyle } from '../../utils'

const StyledGlossary = styled.div`
  cursor: pointer;
`

const StyledIconContainer = styled.div`
  position: absolute;
  top: 0;
  right: 16px;
  z-index: 1;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  
  width: 24px;
  height: 24px;
  background-color: #fff;
  border: 1px solid #f2f3f5;
  border-radius: 50%;
`

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  
  padding: 24px 30px 33px;
  background-color: #fff;
  
  ${props => breakpointStyle(props.theme.media.tablet, `
    position: absolute;
    left: auto;
    right: -122px;
    bottom: 60px;
  
    width: 428px;
    padding: 24px;
    box-shadow: 0 8px 16px rgba(40, 88, 162, 0.06);
  `)}
`

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 101;
  background-color: rgba(34, 34, 34, 0.2);
  
  ${props => breakpointStyle(props.theme.media.tablet, `
    position: static;
  `)}
`

const StyledContent = styled.div`
  p {
  margin-bottom: 32px;
    font-weight: ${props => props.theme.fontWeight.normal};
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${props => props.theme.colors.black};  
  }
  
  figure {
    max-width: 100%;
    
    > img {
      max-width: 100%;
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
`

const StyledCose = styled.button`
  margin: 32px auto 0;
  
  background-color: inherit;
  border: none;
  color: ${props => props.theme.colors.gray};
  font-size: 0.875rem;
  font-weight: ${props => props.theme.fontWeight.semiBold};
  
  ${props => breakpointStyle(props.theme.media.tablet, `
    display: none;
  `)}
`

export {
  StyledGlossary,
  StyledIconContainer,
  StyledContainer,
  StyledOverlay,
  StyledContent,
  StyledCose
}



// WEBPACK FOOTER //
// ./src/components/Glossary/StyledGlossary.js